import { render, staticRenderFns } from "./paper-result-new-practice-h5.vue?vue&type=template&id=4c60943e&scoped=true"
import script from "./paper-result-new-practice-h5.vue?vue&type=script&lang=ts"
export * from "./paper-result-new-practice-h5.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-new-practice-h5.vue?vue&type=style&index=0&id=4c60943e&prod&lang=scss&scoped=true"
import style1 from "./paper-result-new-practice-h5.vue?vue&type=style&index=1&id=4c60943e&prod&lang=scss&scoped=true"
import style2 from "./paper-result-new-practice-h5.vue?vue&type=style&index=2&id=4c60943e&prod&lang=scss"
import style3 from "./paper-result-new-practice-h5.vue?vue&type=style&index=3&id=4c60943e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60943e",
  null
  
)

export default component.exports